// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2s6ZS","rootNoMargin":"styles_rootNoMargin__3DguV"};